// extracted by mini-css-extract-plugin
module.exports = {"list":"styles_list__9YuiO","card":"styles_card__1LDKr"};